(ns frontend.view.modals.guest-invite.events
  (:require [frontend.actions.account :as account-actions]
            [frontend.view.modals.components.processing-modal :as processing-modal]
            [frontend.state.current-session :as session]))

(defn select-person! [state person-id]
  (let [person (get @session/entities person-id)]
    (swap! state assoc
           :selected-person-id person-id
           :new-email (:person/universal-email-address person)
           :new-first-name (:person/first-name person)
           :new-last-name (:person/last-name person))))

(defn invite-guest! [target-id guest-role state]
  (processing-modal/start-processing! state)

  (let [{:keys [selected-person-id
                new-email
                new-first-name
                new-last-name]} @state
        msg {:target-id target-id
             :person-id selected-person-id
             :account   {:account/email      new-email
                         :account/first-name new-first-name
                         :account/last-name  new-last-name}
             :role      guest-role}]
    (account-actions/*->invite-guest
      msg
      (fn [e]
        (processing-modal/success! state))
      (fn [response]
        (processing-modal/error! state response)))))
